<template>
    <div id="multi-date-picker-hc">
        <div :class="`multi-date-picker ${alignLeftStart ? 'multi-date-picker-left' : ''}`" ref="multiDatePicker">
            <input class="form form-control pe-4" :value="result" ref="multiDatePickerInput" />
            <span class="multi-date-picker-clear" @click="clearResult()" v-tooltip="{ title: `Clear` }">
                <i class="fas fa-times"></i>
            </span>
            <div class="multi-calendar-wrapper" v-show="showCalendar" ref="_calendarElementWrapper">
                <div class="multi-calendar-element"></div>
                <div class="multi-calendar-element"></div>
                <div class="multi-calendar-element"></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="./MultiDatePickerHC.scss"></style>
<script lang="ts" src="./MultiDatePickerHC"></script>
